import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class SetSelectedAgencyHeaderInterceptor implements HttpInterceptor {
    public static SELECTED_AGENCY_CODE: string | null = null;
    public static SELECTED_AGENCY_HEADER_NAME: string = 'x-s7-requests-impersonation-agency-code';
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (SetSelectedAgencyHeaderInterceptor.SELECTED_AGENCY_CODE) {
            const requestClone = request.clone({
                headers: request.headers.set(
                    SetSelectedAgencyHeaderInterceptor.SELECTED_AGENCY_HEADER_NAME,
                    SetSelectedAgencyHeaderInterceptor.SELECTED_AGENCY_CODE
                )
            });
            return next.handle(requestClone);
        }
        return next.handle(request);
    }
}
